/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Install_Android_Step2Inputs */

const cs_pwa_install_android_step2 = /** @type {(inputs: Pwa_Install_Android_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klepněte na „Nainstalovat aplikaci“ nebo „Přidat na plochu“.`)
};

const en_pwa_install_android_step2 = /** @type {(inputs: Pwa_Install_Android_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap “Install app” or “Add to Home screen”.`)
};

/**
* | output |
* | --- |
* | "Tap “Install app” or “Add to Home screen”." |
*
* @param {Pwa_Install_Android_Step2Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pwa_install_android_step2 = /** @type {((inputs?: Pwa_Install_Android_Step2Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Install_Android_Step2Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pwa_install_android_step2(inputs)
	return cs_pwa_install_android_step2(inputs)
});